query nextMessages($input: NextMessagesInput!) {
  nextMessages(input: $input) {
    id
    firstName
    lastName
    email
    scheduledAt
    actions
    conversionCountByType {
      RETURN_CALL
      IN_APP_VALUATION
      VALUATION
      DOWNLOAD
      LIFE_ANNUITY
      PARTIAL_SALE
      PLOT_VALUATION
      PROPERTY_REQUEST
    }
  }
}
